import React, { type JSX } from 'react'
import { Observable } from 'rx'
import { hexColors } from '@mobi/settings'
import { QuickbetState, state$ as quickbetState$ } from '@core/Areas/Quickbet/driver'
import { ToggleEachWay } from '@core/Areas/Quickbet/signals'
import { observeImmutable } from '@core/Components/HOCs'
import { InvestmentState, state$ as investmentState$ } from '../BetInvestment/driver'
import { Checkbox } from './Components/Checkbox/Checkbox'

interface EachWayCheckboxProps {
  isEachWay: boolean
  isUsingBonusBet: boolean
}

const state$ = Observable.combineLatest(
  quickbetState$,
  investmentState$,
  (quickbetRecord, investmentRecord): EachWayCheckboxProps => {
    const quickbetState = quickbetRecord.toJS() as QuickbetState
    const investmentState = investmentRecord.toJS() as InvestmentState
    return {
      isEachWay: quickbetState.isEachWay,
      isUsingBonusBet: !!investmentState.bonusBet,
    }
  }
)

export const EachWayCheckboxComponent = ({
  isEachWay,
  isUsingBonusBet,
}: EachWayCheckboxProps): JSX.Element => {
  const toggleEachWay = () => ToggleEachWay()
  return (
    <Checkbox
      id='quickbet-eachway-checkbox'
      color={hexColors.white}
      label='Each Way'
      checked={isEachWay}
      onChange={toggleEachWay}
      disabled={isUsingBonusBet}
      includePadding={false}
    />
  )
}

export default observeImmutable(state$, ({ record }) => <EachWayCheckboxComponent {...record} />)
